
  <div class="hotel-map-info">
    <div class="hotel-map-info__container">
      <div class="hotel-map-info__container__info">
        
        <a [href]="detailUrl" target="_blank" (click)="trackEvent()">

          <p class="hotel-map-info__container__info__hotel-title">{{ hotelSelected.name }}</p>

          <div class="hotel-map-info__container__info__stars">
            <ng-template #hotelProvider>
              <mb-stars-rating *ngIf="hotelSelected?.stars != 0" [rating]="hotelSelected?.stars"></mb-stars-rating>
            </ng-template>
            <span class="hotel-map-info__container__info__temporary" 
              *ngIf="hotelSelected?.isHomestays; else hotelProvider">
              Alquiler temporario
            </span>
            <ng-container *ngIf="hotelSelected?.amenities?.length > 0">
              <ng-container *ngFor="let iconName of hotelSelected.amenities | slice: 0:4; trackBy: trackByItems">
                <ng-template #tooltip>
                  <div class="text__amenity">{{ iconName.description }}</div>
                </ng-template>
                <mb-icon class="icon__amenity" [mb-tooltip]="tooltip" mbTooltipColor="dark"
                  mbTooltipPosition="below" [icon]="iconName.icon"></mb-icon>
              </ng-container>
            </ng-container> 
          </div>

          <ng-container *ngIf="hotelSelected?.meal_plan">
            <mb-badge  class="hotel-map-info__container__info__meal-plan" 
            *ngIf="getMealPlanIcon(hotelSelected?.meal_plan?.code) as icon" 
            size="small" 
            color="light">
              {{ hotelSelected.meal_plan.description }}
            </mb-badge>
          </ng-container>
     
          <ng-container *ngIf="getPaymentBadgeText(hotelSelected) as text">
            <mb-badge class="hotel-map-info__container__info__refundable" size="small">
              {{ text | slice: 0:20 }}
              <ng-container *ngIf="text.length > 20">...</ng-container>
            </mb-badge>
          </ng-container>
        </a>

        <div class="hotel-map-info__container__info__price-container" [ngClass]="{'no-discount':hotelSelected?.discount_percentage < 5}">
         <div class="price__discount" *ngIf="hotelSelected?.discount_percentage >= 5">
           <mb-advice [align]="'right'" size="small" color="success" class="price__gift">
             {{ hotelSelected?.discount_percentage }}% OFF
           </mb-advice>
           <div class="price__without-discount">
             <strong><s>{{ currencyLabel }}{{ hotelSelected?.price_without_discount | Currency }}</s></strong>
           </div>
         </div>

          <div class="hotel-map-info__container__info__price-container__price-night" [ngClass]="{'discount':hotelSelected?.discount_percentage >= 5}">
            <span class="hotel-map-info__container__info__price-text">Precio por noche</span>
            <div *ngIf="hotelSelected?.price && !isAlliance">
              <p class="price price--lg">
                <span class="price__currency">{{currencyLabel}}&nbsp;</span>
                <span class="price__amount">{{ priceToDisplay | Currency }}</span>
              </p>
            </div>
          </div>
          <div class="hotel-map-info__container__info__price-container__price-tax-container">
            <am-rewards-pricing [price]="priceToDisplay" *ngIf="isAlliance"></am-rewards-pricing>
            <div class="tax-info">
              <span *ngIf="getTaxInfoText() as taxText">{{ taxText }}</span>
              <mb-icon icon="info" class="icon-focus" (click)="expandBreakdown()"></mb-icon>
            </div>
            <div class="total-price__wrapper"> 
              <p class="total-price">Precio total</p>
              <p class="total-price">{{currencyLabel}} {{ hotelSelected?.total | Currency }}</p>
            </div>
          </div>
          
          <am-pricing-expandable class="hotel-map-info__container__info__price-container__price-tax-container__expandable" [rateId]="pricingKey" [fop]="hotelSelected?.payment_methods[0].code"
          [currencyCode]="hotelSelected?.currency" #pricingExpandable></am-pricing-expandable> 
        </div>
      </div>
    </div>
  </div>
